import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import withBaseLayout from '../../components/BaseLayout/withBaseLayout.js';
import PageHeading from '../../components/PageHeading/PageHeading.js';
import BackLink from '../../components/BackLink/BackLink';

import { getString } from '../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'services';

function ServiceLandingLayout(props) {
  const { classes, serviceCards, backAction } = props;

  return (
    <div className={`${classes.root} PageLayout`}>
      <BackLink action={backAction} />
      <PageHeading heading={getString(stringsComponent, 'TITLE')} />
      <Grid container spacing={0} className='DashGridContainer'>
        {serviceCards.map((card, i) => {
          return (
            <React.Fragment key={i}>
              <Grid
                item
                xs={12}
                sm={6}
                md={12}
                lg={6}
                className={`${classes.gridItem} DashGridColumn`}
              >
                <React.Fragment key={i}>{card}</React.Fragment>
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
      <BackLink action={backAction} />
    </div>
  );
}

ServiceLandingLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  serviceCards: PropTypes.array,
  backAction: PropTypes.func.isRequired,
};

ServiceLandingLayout.defaultProps = {};

export default withBaseLayout(withStyles(styles)(ServiceLandingLayout));
